




















import { defineClassComponent } from '@/hooks'
import { navigateTo } from '@/router'

export default defineClassComponent<{
  count: number
}>(
  {
    props: ['count'],
  },
  () =>
    class {
      handleClick = () => {
        navigateTo('GroupBuyingOrderIndex', {
          active: 1,
        })
      }
    },
)
